import api from "./api";

export interface SubscriptionSummary {
  plan: string;
  planLabel: string;
  planDescription: string;
  planUrl: string;
  priceRub: number | null;
  usage: number;
  subscriptionStatus: string;
  limit: number;
}

export const getSubscription = async (): Promise<SubscriptionSummary> => {
  const response = await api.get<SubscriptionSummary>("/subscription");
  return response.data;
};

export const createSubscription = async (plan: string) => {
  const response = await api.post("/subscription/create", { plan });
  return response.data;
};
